// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-button{display:flex;line-height:normal;gap:5px}
`, "",{"version":3,"sources":["webpack://./src/processes/massive_actions/CensusCooler/components/SummaryCardFooter/styles.scss"],"names":[],"mappings":"AAAA,aACE,YAAa,CACb,kBAAmB,CACnB,OACF","sourcesContent":[".icon-button {\n  display: flex;\n  line-height: normal;\n  gap: 5px\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
